<template>
  <div ref="notification" class="notification_invite" :style="'transform: translate(0, '+transform+'px)'">
    <div class="modal_qualifier_container">
      <div class="top_qualifier_modal">
        <a class="daily_close close_modal_qualifiers close_notification" @click="close()">
          <i class="sp-ic-sm-modal-close sp-ic-sm-modal-close-14x14" />
        </a>
        <div class="daily_title notification_text" style="font-weight: bold;font-size: 16px">Notification</div>
      </div>
      <notification-item :notification="notification" :animation="true" />
    </div>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import jQuery from 'jquery';

export default {
  mixins: [component],
  props: {
    notification: {
      type: String,
      default: '',
    },
    transform: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    const element = jQuery(this.$refs.notification);
    element.animate({ right: '10px' }, 700, function() {
      element.find('.progress_bar_orange').animate({ width: '0%' }, 10000);
    });
    element.delay(10000).animate({ right: '-500px' }, 700, () => {
      this.$store.dispatch('notifications/removeNotificationPopup', this.notification);
    });
  },
  methods: {
    getHeight() {
      return this.$refs.notification.clientHeight;
    },
    close() {
      const element = jQuery(this.$refs.notification);
      element.stop();
      element.animate({ right: '-500px' }, 1000, () => {
        this.$store.dispatch('notifications/removeNotificationPopup', this.notification);
      });
    },
  },
};
</script>
